import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun } from 'mobx';
import moment from 'moment';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, DateInput, SelectInput, TextInput } from '../Form';
import {toJS} from "mobx/lib/mobx";
import FormMultiSelectInput from "../FormMultiSelectInput";

@inject('qcRuleStore', 'qcTypeStore', 'qcFlagStore')
@observer
class QCRuleModify extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    qcRuleStore: PropTypes.object.isRequired,
    qcTypeStore: PropTypes.object.isRequired,
  }

  @observable editMode = false;

  slug = '/qc/rule';
  // title = 'Edit QC Rule';
  disposer = null;
  @observable monthsOptions = [
    {id: '01', label: 'January', value: false},
    {id: '02', label: 'February', value: false},
    {id: '03', label: 'March', value: false},
    {id: '04', label: 'April', value: false},
    {id: '05', label: 'May', value: false},
    {id: '06', label: 'June', value: false},
    {id: '07', label: 'July', value: false},
    {id: '08', label: 'August', value: false},
    {id: '09', label: 'September', value: false},
    {id: '10', label: 'October', value: false},
    {id: '11', label: 'November', value: false},
    {id: '12', label: 'December', value: false},
  ];
  @observable item = {
    type: '',
    type_name: '',
    description: '',
    start_date: '',
    end_date: '',
    applicable_months: '',
    qc_flag: '',
    threshold: {
      lower_threshold: '',
      upper_threshold: '',
    },
    step: {
      max_change: '',
      interval: '',
    },
    constant: {
      threshold: '',
      interval: '',
    },
    value_check: {
      reference: '',
    },
  };

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }


  componentWillMount() {
    const { params: { id }, qcRuleStore } = this.props;

    this.editMode = id !== 'add';
    if (this.editMode) {
      qcRuleStore.fetchItem(id);

      this.disposer = autorun(() => {
        const foundItem = qcRuleStore.findById(id);
        this.reset(foundItem.asJson);
      });
  
      this.title = 'Edit QC Rule';
    } else this.title = 'Add QC Rule';

  }

  componentWillUnmount() {
    if (this.editMode) {
      this.disposer();
    }
  }

  @action reset(foundItem) {
    const { params: { id }, qcRuleStore } = this.props;
    const item = foundItem;
    if (item) {
      if(!!item.applicable_months) item.applicable_months.toString().split(',').forEach(item => {
        this.monthsOptions.filter(month => +month.id === +item)[0].value = true;
      });
      this.item = {
        ...item,
        id,
        start_date: moment(item.start_date).format('YYYY-MM-DD'),
        end_date: moment(item.end_date).format('YYYY-MM-DD'),
      };
    }
  }

  @action onChangeType = (e) => {
    const { qcTypeStore } = this.props;
    this.item.type = e.target.value;
    const foundItem = qcTypeStore.findById(this.item.type);
    this.item.type_name = foundItem && foundItem.name;
  }
  @action onChangeDescription = (e) => { this.item.description = e.target.value; }
  @action onChangeStartDate = (e) => { this.item.start_date = e.target.value; }
  @action onChangeEndDate = (e) => { this.item.end_date = e.target.value; }
  @action onChangeApplicableMonths = (e) => { this.item.applicable_months = e.target.value; }
  @action onChangeApplicableMonths = item => item.value = !item.value;
  @action onChangeErrorFlag = (e) => { this.item.qc_flag = e.target.value; }

  // Threshold
  @action onChangeThresholdLowerThreshold = (e) => {
    this.item.threshold.lower_threshold = e.target.value;
  }

  @action onChangeThresholdUpperThreshold = (e) => {
    this.item.threshold.upper_threshold = e.target.value;
  }

  // Step
  @action onChangeStepMaxChange = (e) => { this.item.step.max_change = e.target.value; }
  @action onChangeStepInterval = (e) => { this.item.step.interval = e.target.value; }

  // Constant
  @action onChangeConstantThreshold = (e) => { this.item.constant.threshold = e.target.value; }
  @action onChangeConstantInterval = (e) => { this.item.constant.interval = e.target.value; }

  // Missing/Error Value Check
  @action onChangeValueCheckReference = (e) => { this.item.value_check.reference = e.target.value; }

  onChange(field, event) {
    this.qcRule = {
      ...this.qcRule,
      [field]: event.target.value,
    };
  }

  selectedOptionsReducer = options => options.reduce((acc, item) => {
    if(item.value === true) acc.push(+item.id);
    return acc;
  }, []);

  handleSave = (e) => {
    e.preventDefault();

    const { notify, router } = this.context;
    const { qcRuleStore } = this.props;

    (this.editMode ?  qcRuleStore.updateItem(Object.assign({}, toJS(this.item), {applicable_months: this.selectedOptionsReducer(this.monthsOptions).join(',')})) : qcRuleStore.createItem(Object.assign({}, toJS(this.item), {applicable_months: this.selectedOptionsReducer(this.monthsOptions).join(',')})))
      .then(() => {
        notify.success();
        router.push(this.slug);
      }).catch(notify.error);
  };

  render() {
    const { qcRuleStore, qcTypeStore, qcFlagStore, params: { id } } = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isSaving={qcRuleStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            {this.editMode ? <TextInput label={'Id'} value={id} readOnly /> : ''}
            <SelectInput
              label={'Type'}
              value={this.item.type}
              options={qcTypeStore.items}
              onChange={this.onChangeType}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />
            <TextInput
              label={'Description'}
              value={this.item.description}
              onChange={this.onChangeDescription}
            />
            <DateInput
              label={'Start Date'}
              value={this.item.start_date}
              onChange={this.onChangeStartDate}
            />
            <DateInput
              label={'End Date'}
              value={this.item.end_date}
              onChange={this.onChangeEndDate}
            />
            {/*<TextInput*/}
              {/*label={'Applicable Months'}*/}
              {/*value={this.item.applicable_months}*/}
              {/*onChange={this.onChangeApplicableMonths}*/}
            {/*/>*/}
            <FormMultiSelectInput id='months-multi-select' label='Applicable Months' options={this.monthsOptions} optionClicked={this.onChangeApplicableMonths} sortBy='id'/>
            {/*<TextInput*/}
              {/*label={'Error Flag'}*/}
              {/*value={this.item.qc_flag}*/}
              {/*onChange={this.onChangeErrorFlag}*/}
            {/*/>*/}
            <SelectInput label='QC Flag' value={this.item.qc_flag} onChange={this.onChangeErrorFlag} options={qcFlagStore.items} fields={{label: 'description', value: 'caption'}}/>

            {+this.item.type === 1 && (
              <div className='bordered'>
                <div className="modalHeader">Threshold</div>
                <TextInput
                  label={'Lower Threshold'}
                  value={this.item.threshold.lower_threshold}
                  onChange={this.onChangeThresholdLowerThreshold}
                />
                <TextInput
                  label={'Upper Threshold'}
                  value={this.item.threshold.upper_threshold}
                  onChange={this.onChangeThresholdUpperThreshold}
                />
              </div>
            )}
            {+this.item.type === 2 && (
              <div>
                <div className="modalHeader">Step</div>
                <TextInput
                  label={'Max Change'}
                  value={this.item.step.max_change}
                  onChange={this.onChangeStepMaxChange}
                />
                <TextInput
                  label={'Interval'}
                  value={this.item.step.interval}
                  onChange={this.onChangeStepInterval}
                />
              </div>
            )}
            {+this.item.type === 3 && (
              <div>
                <div className="modalHeader">Constant</div>
                <TextInput
                  label={'Threshold'}
                  value={this.item.constant.threshold}
                  onChange={this.onChangeConstantThreshold}
                />
                <TextInput
                  label={'Interval'}
                  value={this.item.constant.interval}
                  onChange={this.onChangeConstantInterval}
                />
              </div>
            )}
            {+this.item.type === 4 && (
              <div>
                <div className="modalHeader">
                  Missing/Error Value Check
                </div>
                <TextInput
                  label={'Reference'}
                  value={this.item.value_check.reference}
                  onChange={this.onChangeValueCheckReference}
                />
              </div>
            )}
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default QCRuleModify;



// WEBPACK FOOTER //
// ./src/components/QCRule/QCRuleModify.js